/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import 'react-step-progress-bar/styles.css';

import { ProgressBar, Step } from 'react-step-progress-bar';

import { Typography, Box } from '@mui/material';

import { dateFormat } from '../../../../../core/utils/dateFormat';
import { StepIcon } from './styles';

// As for now we have 6 different status, the step bar must divided in 5 equal parts
function getPercentage(statusHistory) {
  const lastStatus = statusHistory[0];
  const { index } = lastStatus.status;
  // Rejected case, will be treated as approved status (index 3)
  if (index === 7) return Math.ceil((3 - 1) * (100 / 5));
  return Math.ceil((index - 1) * (100 / 5));
}

function getTimestampOfStatusByIndex(statusHistory, index) {
  /* We search for the status timestamp given the status index.
  In the case of the third index, on the step bar, this position can represent either the approved state (3)
  as the rejected state (7). Bacause of that we first do a normal search, if no status with that index was found
  we check if the searched status was with index 3. Then we search again for the index 7 (can be a rejected status)
  if it is not, just return an empty string, ie. return the timestamp of the rejected status */
  const value = statusHistory.find((e) => e.status.index === index);
  if (!value) {
    if (index === 3) {
      const rejectedValue = statusHistory.find((e) => e.status.index === 7);
      if (!rejectedValue) return '';
      return dateFormat(rejectedValue.timestamp);
    }
    return '';
  }
  return dateFormat(value.timestamp);
}

export function StatusStepBar({ orderDetails }) {
  const [percentage, setPercentage] = useState(0);

  // This use effect is used only to show the step bar animation
  useEffect(() => {
    setPercentage(getPercentage(orderDetails.statusHistory));
  });

  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'auto',
        height: '150px',
        padding: '10px 0px',
      }}
    >
      <Box sx={{ padding: '30px 50px', minWidth: '600px' }}>
        <ProgressBar
          percent={percentage}
          filledBackground="linear-gradient(to right, var(--color-blue-primary), var(--color-blue-50))"
        >
          <Step transition="scale">
            {({ accomplished }) => (
              <StepIcon accomplished={accomplished}>1</StepIcon>
            )}
          </Step>
          <Step transition="scale">
            {({ accomplished }) => (
              <StepIcon accomplished={accomplished}>2</StepIcon>
            )}
          </Step>
          <Step transition="scale">
            {({ accomplished }) => (
              <StepIcon
                isRejectedStatus={orderDetails.status.index === 7}
                accomplished={accomplished}
              >
                3
              </StepIcon>
            )}
          </Step>
          <Step transition="scale">
            {({ accomplished }) => (
              <StepIcon accomplished={accomplished}>4</StepIcon>
            )}
          </Step>
          <Step transition="scale">
            {({ accomplished }) => (
              <StepIcon accomplished={accomplished}>5</StepIcon>
            )}
          </Step>
          <Step transition="scale">
            {({ accomplished }) => (
              <StepIcon accomplished={accomplished}>6</StepIcon>
            )}
          </Step>
        </ProgressBar>
      </Box>
      <Box sx={{ padding: '30px 50px', minWidth: '600px' }}>
        <ProgressBar
          percent={percentage}
          filledBackground="transparent"
          unfilledBackground="transparent"
        >
          <Step>
            {({ accomplished }) => (
              <ItemDescription
                title="Esperando local de devolução"
                accomplished={accomplished}
                timestamp={getTimestampOfStatusByIndex(
                  orderDetails.statusHistory,
                  1,
                )}
              />
            )}
          </Step>
          <Step>
            {({ accomplished }) => (
              <ItemDescription
                title="Pendente de aprovação"
                accomplished={accomplished}
                timestamp={getTimestampOfStatusByIndex(
                  orderDetails.statusHistory,
                  2,
                )}
              />
            )}
          </Step>
          <Step>
            {({ accomplished }) => (
              <ItemDescription
                title={
                  orderDetails.status.index === 7
                    ? 'Rejeitado pelo lojista'
                    : 'Aprovado pelo lojista'
                }
                accomplished={accomplished}
                timestamp={getTimestampOfStatusByIndex(
                  orderDetails.statusHistory,
                  3,
                )}
              />
            )}
          </Step>
          <Step>
            {({ accomplished }) => (
              <ItemDescription
                title="Enviado pelo cliente"
                accomplished={accomplished}
                timestamp={getTimestampOfStatusByIndex(
                  orderDetails.statusHistory,
                  4,
                )}
              />
            )}
          </Step>
          <Step>
            {({ accomplished }) => (
              <ItemDescription
                title="Coletado pela transportadora"
                accomplished={accomplished}
                timestamp={getTimestampOfStatusByIndex(
                  orderDetails.statusHistory,
                  5,
                )}
              />
            )}
          </Step>
          <Step>
            {({ accomplished }) => (
              <ItemDescription
                title="Resolvido"
                accomplished={accomplished}
                timestamp={getTimestampOfStatusByIndex(
                  orderDetails.statusHistory,
                  6,
                )}
              />
            )}
          </Step>
        </ProgressBar>
      </Box>
    </Box>
  );
}

function ItemDescription({ title, accomplished, timestamp }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        width: '100px',
      }}
    >
      <Typography fontSize={13} sx={{ padding: '10px 0' }}>
        {title}
      </Typography>
      {accomplished && <Typography fontSize={11}> {timestamp} </Typography>}
    </Box>
  );
}
